"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DONE_INVOKE_SEND_REFERRAL_DATA = exports.SEND_REFERRAL_DATA = exports.REMOVE_REFERRAL = exports.ADD_REFERRAL = void 0;
exports.ADD_REFERRAL = '@events/ADD_REFERRAL';
exports.REMOVE_REFERRAL = '@events/REMOVE_REFERRAL';
exports.SEND_REFERRAL_DATA = '@events/PUSH_REFERRAL_DATA';
exports.DONE_INVOKE_SEND_REFERRAL_DATA = 'done.invoke.sendReferralData';
//# sourceMappingURL=events.js.map